/**
 * Created by Wu Jian Ping on 2017/2/9.
 */
import store from "@/store"
import { redriectSSO } from "@/utils"
let interceptors: any[] = []
interceptors = [
    (response: any) => {
        const env = process.env.VUE_APP_ENV || "dev"
        if (response.data.code === 0) {
            return response.data.data
            // 10002002 token失效
        } else if (response.data.code === 10002002 && env === "dev") {
            localStorage.removeItem("token")
            return redriectSSO()
            // 10002003 系统无权限
        } else if (response.data.code === 10002003) {
            store.commit("user/setNoPermission")
            return Promise.reject(response.data?.message ?? response.data?.msg ?? "系统无权限")
        } else {
            return Promise.reject(response.data?.message ?? response.data?.msg ?? "服务器报错")
        }
    },
    (error: any) => {
        return Promise.reject(error.message)
    }
]

export default interceptors
